import PropTypes from 'prop-types';
import AceEditor from 'react-ace';
import { useTheme } from 'styled-components';

import Button from '../../../../juristec-ui/core/Button';

import { verifySqlCode } from '../../../../juristec-ui/utils/validators/inputTextValidators';

import { DesktopUpload, File } from '../../../../juristec-ui/icons';

import {
  MainContainer,
  VarTip,
  InputRow,
  FileInfo,
  NoFile,
} from './styled/ThirdStep.styled';

const emptyState = [{}, () => {}];
const emptyFunc = () => {};

const ThirdStep = ({
  inputDBCodeState = emptyState,
  selectedFileState = emptyState,
  openUploadModal = emptyFunc,
}) => {
  const [inputDBCode, setInputDBCode] = inputDBCodeState;
  const [selectedFile, setSelectedFile] = selectedFileState;

  const theme = useTheme();

  const handleDBCode = (e) => {
    setInputDBCode({ value: e, errorMsg: verifySqlCode('Postgresql', e.trim()) });
  };

  return (
    <MainContainer>
      <VarTip>
        Caso o template possua algum modelo SQL e/ou modelo de planilha de dados, você pode
        adicioná-los aqui. Nenhum dos campos é obrigatório.
      </VarTip>
      {/* Código SQL */}
      <span style={{
        color: theme.inputLabel,
        fontSize: '0.85rem',
        fontWeight: 'bold',
        marginBottom: '0.5rem',
      }}
      >
        Código SQL (opcional)
      </span>
      <InputRow style={{ height: '100%' }}>
        <AceEditor
          mode="sql"
          theme="monokai"
          fontSize={14}
          lineHeight={19}
          scrollMargin={[0, 0]}
          enableLiveAutocompletion
          enableBasicAutocompletion
          enableSnippets
          tabSize={4}
          showPrintMargin
          showGutter
          highlightActiveLine
          value={inputDBCode.value}
          style={{ width: '100%', height: '100%', borderRadius: '8px' }}
          onChange={handleDBCode}
          name="CodeEditor"
          editorProps={{ $blockScrolling: true }}
          placeholder="SELECT ... FROM ... WHERE ..."
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            enableMobileMenu: true,
            showLineNumbers: true,
          }}
        />
      </InputRow>
      {inputDBCode.errorMsg.length > 0 && (
        <span style={{
          color: theme.error,
          fontSize: '0.85rem',
          fontWeight: 'bold',
          marginBotton: '0.5rem',
        }}
        >
          {inputDBCode.errorMsg}
        </span>
      )}
      {/* Upload Area */}
      <span style={{
        color: theme.inputLabel,
        fontSize: '0.85rem',
        fontWeight: 'bold',
        margin: '0.5rem 0',
      }}
      >
        Arquivo Modelo (opcional)
      </span>
      <InputRow style={{
        width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      >
        <Button
          size="small"
          shape="rounded"
          onClick={openUploadModal}
        >
          <DesktopUpload />
          Adicionar arquivo
        </Button>
        {selectedFile.name ? (
          <FileInfo>
            <File />
            <span>{selectedFile.name}</span>
          </FileInfo>
        ) : (
          <NoFile>Nenhum arquivo adicionado</NoFile>
        )}
      </InputRow>
    </MainContainer>
  );
};

ThirdStep.propTypes = {
  inputDBCodeState: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.objectOf(
      PropTypes.shape({
        value: PropTypes.string,
        errorMsg: PropTypes.string,
      }),
    ),
    PropTypes.func,
  ])),
  selectedFileState: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.objectOf(
      PropTypes.any,
    ),
    PropTypes.func,
  ])),
  openUploadModal: PropTypes.func,
};

export default ThirdStep;
